
// Generic function to filter a filter's options by a field and value
export function filterOptionsByField(filterObj: any, field: string, value: string) {
  if (!filterObj) return undefined;
  return {
    ...filterObj,
    options: (filterObj.options || []).filter((opt: any) => opt[field] === value)

  };
}

// Utility to clean filter options by removing invalid entries
export function cleanFilterOptions(filterObj: any) {
  if (!filterObj) return undefined;
  return {
    ...filterObj,
    options: (filterObj.options || []).filter((opt: any) =>
      opt.displayName &&
      opt.displayName.trim() !== "" &&
      opt.count > 0
    )
  };
}

// Utility to override displayName for a filter object (without filtering options)
export function setFilterDisplayName(filterObj: any, customName: string) {
  if (!filterObj) return undefined;
  return {
    ...filterObj,
    displayName: customName
  };
}

export const formatMonthFromId = (id: string) => {
  const regex = /^\d{4}(0[1-9]|1[0-2])$/;
  if (!regex.test(id)) throw new Error("Unable to parse id");

  const year = id.substring(0, 4);
  const month = id.substring(4);
  return `${month}/${year}`;
};

export function getActiveFilterCount(filters: Record<string, string[]>): number {
  return Object.values(filters).reduce((acc, arr) => acc + arr.length, 0);
}